var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundsEnabledMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0146 5.18233C48.5513 4.78875 48.0769 4.40819 47.5918 4.0412L45.0249 7.513C45.339 7.75067 45.6479 7.99485 45.9516 8.24538L49.0146 5.18233Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.713 21.2805L48.8799 18.1136C50.816 21.3791 51.9286 25.5935 51.9286 30.0952C51.9286 35.835 50.1199 41.1078 47.1014 44.5422L43.8986 41.6614C46.0835 39.1754 47.6429 35.0001 47.6429 30.0952C47.6429 26.7018 46.8965 23.6576 45.713 21.2805Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0714 15.1255V0.0952148L16.4456 14.9209H0.5V45.2695H8.92742L13.2629 40.934H4.78572V19.2564H17.7123L34.7857 8.06899V19.4112L39.0714 15.1255Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7857 32.2078L39.0714 27.9221V60.0952L19.6344 47.359L22.7551 44.2383L34.7857 52.1214V32.2078Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.927 15.0664L55.0374 11.9561C58.4858 17.1369 60.5 23.3782 60.5 30.0952C60.5 40.7585 55.4239 50.223 47.5918 56.1492L45.0249 52.6774C51.8217 47.5345 56.2143 39.3341 56.2143 30.0952C56.2143 24.5703 54.6435 19.4168 51.927 15.0664Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 3.46019L57.1352 0.0953422L0.5 56.7305L3.86485 60.0953L60.5 3.46019Z",
    fill: "#BCB3D0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundsEnabledMain);
export default __webpack_public_path__ + "static/media/soundsEnabledMain.8fc9ccc37e5dbac9c939ebee03c9d14a.svg";
export { ForwardRef as ReactComponent };